import { ObjectTools } from '../../../tools/object-tools';
import { SolComponentEntry } from '../../../services/dialog.service';

export type DialogContainerVisibility = 'hidden' | 'fadingIn' | 'visible' | 'fadingOut';

export class SolDialogsState {
  private constructor(
    public readonly entries: SolComponentEntry[],
    public readonly visibility: DialogContainerVisibility,
    public readonly visible: boolean,
  ) {}

  public static of(): SolDialogsState {
    return new SolDialogsState([], 'hidden', false);
  }

  public withEntries(entries: SolComponentEntry[]): SolDialogsState {
    return this.copy({ entries }).recalculate();
  }

  public withVisibility(visibility: DialogContainerVisibility): SolDialogsState {
    return this.copy({ visibility }).recalculate();
  }

  public static shouldFade(state: SolDialogsState): boolean {
    const hasEntries = state.entries.length;
    const shouldFadeIn = hasEntries && state.visibility === 'hidden';
    const shouldFadeOut = !hasEntries && state.visibility === 'visible';
    return shouldFadeIn || shouldFadeOut;
  }

  public static calculateVisibility(state: SolDialogsState): DialogContainerVisibility {
    const hasEntries = state.entries.length;
    if (hasEntries) {
      if (state.visibility === 'hidden') {
        return 'fadingIn';
      } else {
        return 'visible';
      }
    } else {
      if (state.visibility === 'visible') {
        return 'fadingOut';
      } else {
        return 'hidden';
      }
    }
  }

  private recalculate(): SolDialogsState {
    const visible = this.visibility !== 'hidden';
    return this.copy({ visible });
  }

  private copy(props: Partial<SolDialogsState>): SolDialogsState {
    return ObjectTools.copy<SolDialogsState>(this, props);
  }
}
